<section class="faq-dropdown-list">
  <div class="text-center subhead">Frequently Asked Questions</div>
  <div class="bb-light mt-5"></div>
  <common-list-dropdown-group [listGroupItems]="listGroupItems"></common-list-dropdown-group>
</section>
